import { Box, Text, useColorModeValue } from '@chakra-ui/react';

import { PR_SHORT } from '../../../constants/watchdogProfitabilityRating';

type RankByPrExplainerProps = {
  /** Single-line caption for tight spaces (e.g. hero teaser). */
  compact?: boolean;
};

export function RankByPrExplainer({ compact = false }: RankByPrExplainerProps) {
  const calloutBg = useColorModeValue('primary.50', 'blackAlpha.350');
  const calloutBorder = useColorModeValue('primary.100', 'whiteAlpha.150');
  const titleColor = useColorModeValue('gray.800', 'gray.100');
  const bodyColor = useColorModeValue('gray.600', 'gray.400');
  const compactColor = useColorModeValue('gray.600', 'gray.300');

  if (compact) {
    return (
      <Text
        fontSize={{ base: 'sm', md: 'md' }}
        fontWeight="medium"
        color={compactColor}
        lineHeight="1.55"
        mb={3}
      >
        Ranked by Profit Rating ({PR_SHORT}) — who would have made you money if
        you followed every pick, not who has the best win rate.
      </Text>
    );
  }

  return (
    <Box
      mb={4}
      p={{ base: 3, md: 4 }}
      borderRadius="12px"
      bg={calloutBg}
      border="1px solid"
      borderColor={calloutBorder}
    >
      <Text
        fontSize={{ base: 'sm', md: 'md' }}
        fontWeight="semibold"
        color={titleColor}
      >
        Ranked by Profit Rating ({PR_SHORT})
      </Text>
      <Text
        fontSize={{ base: 'sm', md: 'md' }}
        color={bodyColor}
        mt={1.5}
        lineHeight="1.6"
      >
        #1 is the expert with the highest modeled profit percentage (%) if you
        tailed every pick (not just the best win rate). WCS grades picking skill
        separately; strong win rates at bad prices can look good on WCS but
        weaker on {PR_SHORT}. Heavy longshot parlays can lower WCS if they
        rarely win, but can have a large positive impact on {PR_SHORT} if the
        odds outperform their win rate.
      </Text>
    </Box>
  );
}
